import { render, staticRenderFns } from "./Correduria.vue?vue&type=template&id=a1e81d72"
import script from "./Correduria.vue?vue&type=script&lang=js"
export * from "./Correduria.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/github/workspace/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a1e81d72')) {
      api.createRecord('a1e81d72', component.options)
    } else {
      api.reload('a1e81d72', component.options)
    }
    module.hot.accept("./Correduria.vue?vue&type=template&id=a1e81d72", function () {
      api.rerender('a1e81d72', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/clients/procesos/cotejo/Correduria.vue"
export default component.exports